import { render, staticRenderFns } from "./FormulaResourceSelection.vue?vue&type=template&id=ff20cede"
import script from "./FormulaResourceSelection.vue?vue&type=script&lang=js"
export * from "./FormulaResourceSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports